import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Main from './components/Main';
import Updates from './components/Updates';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Main />} />
        <Route path="/updates" element={<Updates />} />
      </Routes>
    </Router>
  );
}

export default App;